/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TipoUtilizacaoCriteriaDto } from '../models/tipo-utilizacao-criteria-dto';
import { TipoUtilizacaoDto } from '../models/tipo-utilizacao-dto';
import { TipoUtilizacaoFormDto } from '../models/tipo-utilizacao-form-dto';
import { TipoUtilizacaoPageDto } from '../models/tipo-utilizacao-page-dto';

@Injectable({
  providedIn: 'root',
})
export class TiposUtilizacaoService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTiposUtilizacao
   */
  static readonly GetTiposUtilizacaoPath = '/tipos-utilizacao';

  /**
   * Pesquisar tipos de utilizacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTiposUtilizacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposUtilizacao$Response(params?: {
    criteria?: TipoUtilizacaoCriteriaDto;
  }): Observable<StrictHttpResponse<TipoUtilizacaoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposUtilizacaoService.GetTiposUtilizacaoPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoUtilizacaoPageDto>;
      })
    );
  }

  /**
   * Pesquisar tipos de utilizacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTiposUtilizacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposUtilizacao(params?: {
    criteria?: TipoUtilizacaoCriteriaDto;
  }): Observable<TipoUtilizacaoPageDto> {

    return this.getTiposUtilizacao$Response(params).pipe(
      map((r: StrictHttpResponse<TipoUtilizacaoPageDto>) => r.body as TipoUtilizacaoPageDto)
    );
  }

  /**
   * Path part for operation createTipoUtilizacao
   */
  static readonly CreateTipoUtilizacaoPath = '/tipos-utilizacao';

  /**
   * Criar tipo de utilizacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTipoUtilizacao()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoUtilizacao$Response(params?: {

    /**
     * apiRequest
     */
    body?: TipoUtilizacaoFormDto
  }): Observable<StrictHttpResponse<TipoUtilizacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposUtilizacaoService.CreateTipoUtilizacaoPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoUtilizacaoDto>;
      })
    );
  }

  /**
   * Criar tipo de utilizacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTipoUtilizacao$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoUtilizacao(params?: {

    /**
     * apiRequest
     */
    body?: TipoUtilizacaoFormDto
  }): Observable<TipoUtilizacaoDto> {

    return this.createTipoUtilizacao$Response(params).pipe(
      map((r: StrictHttpResponse<TipoUtilizacaoDto>) => r.body as TipoUtilizacaoDto)
    );
  }

  /**
   * Path part for operation getTipoUtilizacao
   */
  static readonly GetTipoUtilizacaoPath = '/tipos-utilizacao/{id}';

  /**
   * Obter tipo de utilizacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTipoUtilizacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoUtilizacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoUtilizacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposUtilizacaoService.GetTipoUtilizacaoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoUtilizacaoDto>;
      })
    );
  }

  /**
   * Obter tipo de utilizacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTipoUtilizacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoUtilizacao(params: {
    id: number;
  }): Observable<TipoUtilizacaoDto> {

    return this.getTipoUtilizacao$Response(params).pipe(
      map((r: StrictHttpResponse<TipoUtilizacaoDto>) => r.body as TipoUtilizacaoDto)
    );
  }

  /**
   * Path part for operation updateTipoUtilizacao
   */
  static readonly UpdateTipoUtilizacaoPath = '/tipos-utilizacao/{id}';

  /**
   * Atualizar tipo de utilizacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTipoUtilizacao()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoUtilizacao$Response(params: {
    id: number;
    body?: TipoUtilizacaoFormDto
  }): Observable<StrictHttpResponse<TipoUtilizacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposUtilizacaoService.UpdateTipoUtilizacaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoUtilizacaoDto>;
      })
    );
  }

  /**
   * Atualizar tipo de utilizacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTipoUtilizacao$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoUtilizacao(params: {
    id: number;
    body?: TipoUtilizacaoFormDto
  }): Observable<TipoUtilizacaoDto> {

    return this.updateTipoUtilizacao$Response(params).pipe(
      map((r: StrictHttpResponse<TipoUtilizacaoDto>) => r.body as TipoUtilizacaoDto)
    );
  }

  /**
   * Path part for operation ativarTipoUtilizacao
   */
  static readonly AtivarTipoUtilizacaoPath = '/tipos-utilizacao/{id}/ativar';

  /**
   * Ativar Tipo Utilizacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarTipoUtilizacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoUtilizacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoUtilizacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposUtilizacaoService.AtivarTipoUtilizacaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoUtilizacaoDto>;
      })
    );
  }

  /**
   * Ativar Tipo Utilizacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarTipoUtilizacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoUtilizacao(params: {
    id: number;
  }): Observable<TipoUtilizacaoDto> {

    return this.ativarTipoUtilizacao$Response(params).pipe(
      map((r: StrictHttpResponse<TipoUtilizacaoDto>) => r.body as TipoUtilizacaoDto)
    );
  }

  /**
   * Path part for operation desativarTipoUtilizacao
   */
  static readonly DesativarTipoUtilizacaoPath = '/tipos-utilizacao/{id}/desativar';

  /**
   * Desativar TipoUtilizacao.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarTipoUtilizacao()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoUtilizacao$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoUtilizacaoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposUtilizacaoService.DesativarTipoUtilizacaoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoUtilizacaoDto>;
      })
    );
  }

  /**
   * Desativar TipoUtilizacao.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarTipoUtilizacao$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoUtilizacao(params: {
    id: number;
  }): Observable<TipoUtilizacaoDto> {

    return this.desativarTipoUtilizacao$Response(params).pipe(
      map((r: StrictHttpResponse<TipoUtilizacaoDto>) => r.body as TipoUtilizacaoDto)
    );
  }

}
